export default __webpack_public_path__ + "static/media/icon_delete.7c974066.svg";